
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-search-services",
      function () {
        return require("private-next-pages/trademark-search-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-search-services"])
      });
    }
  